<template>
  <v-card>
    <v-card-title>
      {{ $t('title.settings_scan_choice') }}
      <v-btn
        absolute
        right
        icon
        outlined
        x-small
        @click="$refs.subScan.classList.remove('d-none')"
      >
        <v-icon>mdi-help</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-subtitle
      ref="subScan"
      class="d-none"
    >
      {{ $t('title.settings_scan_choice_desc') }}
    </v-card-subtitle>
    <v-card-text>
      <!--<v-select-->
      <!--  v-model="favoriteScan"-->
      <!--  :label="$t('field.settings.scan_tech')"-->
      <!--  :items="typeScan"-->
      <!--  solo hide-details-->
      <!--/>-->
      <v-row>
        <v-col cols="10">
          <span>Technologie</span>
          <v-switch
            v-model="usenfc"
            :label="`${$t('field.settings.contactless')} ${usenfc ? 'ON' : 'OFF'}`"
            color="accent"
            hide-details
          />
          <v-switch
            v-model="useqrcodes"
            :label="`${$t('field.settings.qr_code')} ${useqrcodes ? 'ON' : 'OFF'}`"
            color="accent"
            hide-details
          />
          <v-switch
            v-model="usemanscan"
            :label="`${$t('field.settings.man_scan')} ${usemanscan ? 'ON' : 'OFF'}`"
            color="accent"
            hide-details
          />
          <v-switch
            v-if="IS_PAX"
            :input-value="true"
            :label="`${$t('field.settings.swipe')} ON`"
            color="accent"
            hide-details
            disabled
          />
          <v-switch
            v-else-if="IS_DESKTOP"
            :input-value="true"
            :label="`${$t('enums.type_scan.qr_usb')} ON`"
            color="accent"
            hide-details
            disabled
          />
        </v-col>
        <v-col
          cols="2"
          class="text-right"
        >
          <span>Favori</span>
          <v-btn
            v-for="(type, index) in TypeScanEnum"
            v-show="type.show"
            :key="index"
            icon
            class="mt-2 mb-1"
            @click="favoriteScan = index"
          >
            <v-icon>{{ favoriteScan === index ? 'mdi-star' : 'mdi-star-outline' }}</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { MetierLocalStorage } from 'modulelocalstorage'
import { TypeScanEnum } from '@/modules/Enums'

export default {
  name: 'ScanSettings',

  data () {
    return {
      IS_DESKTOP,
      IS_PAX,
      TypeScanEnum
    }
  },

  computed: {
    usemanscan: {
      get () { return this.$store.state.usemanscan },
      set (val) {
        // Changement du scan par défaut en cas de désactivation
        if (val === false && this.favoriteScan === 2) {
          if (this.useqrcodes) {
            this.favoriteScan = 1;
          } else {
            this.favoriteScan = 0;
          }
        }
        this.$store.commit('usemanscan', val)
        localStorage.setItem('usemanscan', val)
      }
    },
    usenfc: {
      get () { return this.$store.state.usenfc },
      set (val) {
        // Changement du scan par défaut en cas de désactivation
        if (val === false && this.favoriteScan === 0) {
          this.favoriteScan = this.useqrcodes ? 1 : 2
        }
        this.$store.commit('usenfc', val)
        localStorage.setItem('usenfc', val)
      }
    },
    useqrcodes: {
      get () { return this.$store.state.useqrcodes },
      set (val) {
        // Changement du scan par défaut en cas de désactivation
        if (val === false && this.favoriteScan === 1) {
          this.favoriteScan = this.usenfc ? 0 : 2
        }
        this.$store.commit('useqrcodes', val)
        localStorage.setItem('useqrcodes', val)
      }
    },
    favoriteScan: {
      get () { return this.$store.state.favoriteScan },
      set (val) {
        // Activation de la fonctionnalité si prise par défaut
        if (val === 0) {
          this.usenfc = true
        } else if (val === 1) {
          this.useqrcodes = true
        } else if (val === 2) {
          this.usemanscan = true
        }

        MetierLocalStorage.setFavoriteScan(val)
        this.$store.commit('favoriteScan', val)
      }
    }
  }
}
</script>
